import React from 'react';
import BeatLoader from 'react-spinners/BeatLoader';

const Loader = React.forwardRef((props, ref) => {
    return (
        <div
            ref={ref}
            style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '15px',
            }}
        >
            <BeatLoader color={'#464c5e'} />
        </div>
    );
});

export default Loader;
